export default [
  {
    title: "الرئيسية",
    route: "#",
    icon: "HomeIcon",
  },
  {
    title: "قائمة الطلبات",
    route: "RequestsList",
    icon: "BoxIcon",
  },
  {
    title: "المستخدمين",
    route: "#",
    icon: "BoxIcon",
    children: [
      {
        title: "التجار",
        route: "#",
        icon: "",
      },
      {
        title: "المهندسين",
        route: "#",
        icon: "",
      },
      {
        title: "المحامين",
        route: "#",
        icon: "",
      },
    ],
  },
  {
    title: "الموظفين",
    route: "#",
    icon: "BoxIcon",
    children: [
      {
        title: "اضافة موظف",
        route: "#",
        icon: "",
      },
      {
        title: "قائمة الموظفين",
        route: "#",
        icon: "",
      },
    ],
  },
  {
    title: "الإعدادات",
    route: "#",
    icon: "SettingsIcon",
  },
];
